import React from 'react'
import BulkIndexingForm from './BulkIndexingForm'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function BulkIndexing() {
  SetTitle('Bulk Indexing')
  const description =
    "Una volta raccolti gli url dal file e dal form verranno indicizzati dall'API di google."

  return (
    <Header
      iconClass="fa fa-rss"
      title="Bulk Indexing"
      docLink="/docs/ranking_tools/bulk-indexing/"
      description={description}
    >
      <BulkIndexingForm />
    </Header>
  )
}